import React, { useState, useCallback } from "react";
import { NumericFormat, PatternFormat } from "react-number-format";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../store/selectors/app.selector";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Divider, Modal, Select, Switch } from "antd";
import { CONFIG } from "../environment";
import { setSelectedAccount } from "../store/actions/app.action";
import BANK_LOGO from "client/assets/LOGO/BANK_LOGO_WHITE.png";
import {
  accNoFormat,
  amountFormat,
  amountNoCurrencyFormat,
  maskAccountNumber,
} from "../services/common.service";
import moment from "moment";
import { useTranslation } from "react-i18next";

export default function AccountSelectedCard() {
  const accountList = useSelector(accountListSelector);
  const dispatch = useDispatch();
  const selectedAccount = useSelector(selectedAccountSelector);
  const [showBalance, setShowBalance] = useState(false);
  const [visible, setVisible] = useState(false);
  const [accno, setAccNo] = useState(selectedAccount?.accountNo);
  const { t } = useTranslation();
  const handleChangeAccount = useCallback(
    (value) => {
      const selectedAccDetails = accountList.find(
        (ele) => ele.accountNo === value.accountNo
      );
      dispatch(setSelectedAccount(selectedAccDetails));
    },
    [accountList]
  );

  return (
    <div>
      {" "}
      <div className={CONFIG.BANK_CARD ? "account-card-selection" : "account-card-selection1"}>
        <div className="accont-selected-card mx-2">
          <div className="d-flex justify-content-end show-balance">
            {!showBalance ? (
              <span className="mt-1">Show Balance</span>
            ) : (
              <span className="mt-1">Hide Balance</span>
            )}{" "}
            <Switch
              onChange={() => setShowBalance(!showBalance)}
              className="custom-switch"
            />
          </div>
          <div className="balance d-flex ">
            {showBalance ? (
              <>
                <span>{selectedAccount?.accountCurrency}</span>

                <span style={{ marginLeft: 10 }}>
                  {amountNoCurrencyFormat(selectedAccount?.avlBalance)}
                </span>
              </>
            ) : (
              <>
                <span className="">{selectedAccount?.accountCurrency}</span>

                <span
                  style={{ letterSpacing: 4, fontSize: "20px", marginLeft: 10 }}
                >
                  ********
                </span>
              </>
            )}
          </div>
          <div className="d-flex align-items-center mt-2">
            <span style={{ letterSpacing: 2 }}>
              {maskAccountNumber(selectedAccount?.accountNo)}
            </span>
            <span className="status-btn">
              {selectedAccount?.status || "ACTIVE"}
            </span>
          </div>

          <div className="mt-4 d-flex justify-content-between align-items-center">
            <span style={{ fontSize: "14px" }}>
              {selectedAccount?.accountName}
            </span>
            <div>
              <Button
                onClick={() => setVisible(true)}
                className="view-btn"
                size="small"
              >
                View Account
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Card className="custom-card-style mt-3">
        {" "}
        <label style={{ fontWeight: "600" }}>
          {t("pages.gepeg.account_details_cap", {
            defaultValue: "ACCOUNT DETAILS",
          })}
        </label>
        <Card className={`account-card`}>
          <div
            className="confirm-details px-1"
            style={{ marginTop: "-12px", marginBottom: "-12px" }}
          >
            <div className=" row">
              <div className="confirm-detail-wrapper">
                <label>
                  {t("pages.my_accounts.common_my_accounts.account_name", {
                    defaultValue: "Account Name",
                  })}
                </label>
                <span>{selectedAccount?.accountName}</span>
              </div>

              <div
                className="confirm-detail-wrapper"
                style={{ border: "none" }}
              >
                <label>
                  {t("pages.my_accounts.casa.nickname", {
                    defaultValue: "Nick Name",
                  })}
                </label>
                <span>{selectedAccount?.acctShortName}</span>
              </div>

              {/* <div className="confirm-detail-wrapper" style={{ border: "none" }}>
              <label>Branch Address</label>
              <span>{selectedAccount?.branchId || "-"}</span>
            </div> */}
            </div>
          </div>
        </Card>
      </Card>
      <Modal
        open={visible}
        footer={null}
        width={450}
        mask={true}
        centered
        onCancel={() => {
          setVisible(false);
        }}
      >
        <div className="confirm-details">
          <label>
            {" "}
            {t("pages.my_accounts.casa.view_acc_details", {
              defaultValue: "View Account Details",
            })}
          </label>
          <span className="confirm-title">{selectedAccount?.accountNo}</span>
          <div className="row">
            <div className="col-12 d-flex justify-content-between ">
              <label className="col-6">
                {" "}
                {t("pages.service_request.account_type", {
                  defaultValue: "Account Type",
                })}
              </label>
              <span
                className="col-6 "
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {selectedAccount.accountType === "SA" &&
                  t("pages.my_accounts.casa.saving_account", {
                    defaultValue: "Saving Account",
                  })}
                {selectedAccount.accountType === "CA" &&
                  t("pages.my_accounts.casa.current_acc", {
                    defaultValue: "Current Account",
                  })}
                {selectedAccount.accountType === "ODA" &&
                  t("pages.my_accounts.casa.over_draft_account", {
                    defaultValue: "Over Draft Account",
                  })}
                {selectedAccount.accountType === "FD" &&
                  t("pages.my_accounts.casa.term_deposit_account", {
                    defaultValue: "Term Deposit Account",
                  })}
                {selectedAccount.accountType === "LA" &&
                  t("pages.my_accounts.casa.loan_acc", {
                    defaultValue: "Investment Account",
                  })}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.my_accounts.common_my_accounts.account_name", {
                  defaultValue: "Account Name",
                })}
              </label>
              <span className="col-6 ">
                {selectedAccount?.accountName || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("common.account_class", {
                  defaultValue: "Account Class",
                })}
              </label>
              <span className="col-6 ">
                {selectedAccount?.accountClass || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {" "}
                {t("common.customer_id", {
                  defaultValue: "Customer ID",
                })}
              </label>
              <span className="col-6">
                {selectedAccount?.customerId || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {" "}
                {t("pages.locateUs.branch", {
                  defaultValue: "Branch",
                })}
              </label>
              <span className="col-6">
                {selectedAccount?.branchId || "-"} &nbsp;
                {selectedAccount?.branchName}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {" "}
                {t("pages.my_accounts.casa.sort_code", {
                  defaultValue: "Sort Code",
                })}
              </label>
              <span
                className="col-6"
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {selectedAccount?.sortCode || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {" "}
                {t("pages.standing_instruction.swift_code", {
                  defaultValue: "Swift Code",
                })}
              </label>
              <span
                className="col-6"
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {selectedAccount?.swiftCode || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("common.currency", {
                  defaultValue: "Currency",
                })}
              </label>
              <span
                className="col-6"
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {selectedAccount?.accountCurrency || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.my_accounts.casa.available_balance", {
                  defaultValue: "Available Balance",
                })}
              </label>
              <span
                className="col-6"
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {amountNoCurrencyFormat(selectedAccount?.avlBalance) || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {" "}
                {t("pages.my_accounts.casa.current_balance", {
                  defaultValue: "Current Balance",
                })}
              </label>
              <span
                className="col-6"
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {amountNoCurrencyFormat(selectedAccount?.currentBalance) || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {t("pages.my_accounts.casa.acc_open_date", {
                  defaultValue: "Account Open Date",
                })}
              </label>
              <span
                className="col-6"
                style={{ fontFamily: "'ubuntuSansRegular'" }}
              >
                {moment(selectedAccount?.acctOpDt).format("DD.MM.YYYY") || "-"}
              </span>
            </div>

            <div className="col-12 d-flex justify-content-between mt-2">
              <label className="col-6">
                {" "}
                {t("pages.my_accounts.casa.acc_desc", {
                  defaultValue: "Account Description",
                })}
              </label>
              <span className="col-6">
                {selectedAccount?.accountClassDesc || "-"}
              </span>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
